import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import {
  SidebarProvider,
  SidebarTrigger,
  SidebarInset,
} from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { ADMIN_ROUTES } from "@/constants";


const MainLayout: React.FC = () => {
  const location = useLocation();

  // Find the current route info from ADMIN_ROUTES
  const currentRoute = Object.values(ADMIN_ROUTES).find(
    (route) => route.link === location.pathname
  );

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2 border-b border-sidebar-border px-4">
          <SidebarTrigger className="-ml-1" />
          <div className="flex flex-col">
            <span className="text-lg font-semibold">
              {currentRoute?.title || "Admin Panel"}
            </span>
            {currentRoute?.desc && (
              <span className="text-sm text-muted-foreground">
                {currentRoute.desc}
              </span>
            )}
          </div>
        </header>
        <main className="flex flex-1 flex-col gap-4 p-4">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default MainLayout;
